import crudActions from '../../crud/actions'

const actions = crudActions('CAREASSESSMENT_EQUIPMENT_')

export default actions
